import Component from '@glimmer/component';

interface LeftBorderCardComponentArgs {
  leftBorderColor?: string;
}

export default class LeftBorderCardComponent extends Component<LeftBorderCardComponentArgs> {
  get leftBorderColor() {
    return this.args.leftBorderColor ?? 'bg-brand';
  }
}
